import { render, staticRenderFns } from "./TheSecondModal.vue?vue&type=template&id=3e903efa&class=fill-height&"
import script from "./TheSecondModal.vue?vue&type=script&lang=ts&"
export * from "./TheSecondModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports